import React from 'react';
import { motion } from 'framer-motion';
import { FaSwimmingPool, FaSpa, FaDumbbell, FaUtensils, FaWifi, FaConciergeBell, FaCar, FaGlassMartiniAlt } from 'react-icons/fa';
import './Amenities.css';

const iconMap = {
  FaSwimmingPool, FaSpa, FaDumbbell, FaUtensils,
  FaWifi, FaConciergeBell, FaCar, FaGlassMartiniAlt,
};

const amenities = [
  { icon: 'FaSwimmingPool', title: 'Infinity Pool', description: 'Rooftop infinity pool with panoramic city views, open year-round.' },
  { icon: 'FaSpa', title: 'Luxury Spa', description: 'Full-service spa offering massages, facials, and wellness treatments.' },
  { icon: 'FaDumbbell', title: 'Fitness Center', description: 'State-of-the-art equipment, personal trainers available 24/7.' },
  { icon: 'FaUtensils', title: 'Fine Dining', description: 'Award-winning restaurant serving international and local cuisine.' },
  { icon: 'FaWifi', title: 'High-Speed WiFi', description: 'Complimentary high-speed internet throughout the property.' },
  { icon: 'FaConciergeBell', title: 'Concierge', description: '24-hour concierge service for tours, reservations, and more.' },
  { icon: 'FaCar', title: 'Valet Parking', description: 'Complimentary valet parking for all hotel guests.' },
  { icon: 'FaGlassMartiniAlt', title: 'Sky Bar', description: 'Rooftop cocktail bar with live music every evening.' },
];

export default function Amenities() {
  return (
    <section className="section amenities-section">
      <div className="amenities-bg" />
      <div className="container">
        <div className="section-header">
          <span className="section-badge" style={{ color: 'var(--primary-light)' }}>World-Class</span>
          <h2 className="section-title" style={{ color: 'var(--white)' }}>Hotel Amenities</h2>
          <div className="gold-line" />
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.7)' }}>
            Every comfort, every luxury, every desire — meticulously crafted to elevate your stay beyond expectations.
          </p>
        </div>

        <div className="amenities-grid">
          {amenities.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <motion.div
                key={item.title}
                className="amenity-card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                whileHover={{ y: -6 }}
              >
                <div className="amenity-icon">
                  {Icon && <Icon />}
                </div>
                <h4 className="amenity-title">{item.title}</h4>
                <p className="amenity-desc">{item.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
